/**
 * gatsby-browser.js
 * Runs in the browser before React hydration.
 * Apply dark mode immediately to prevent a flash of light content.
 */
export const onClientEntry = () => {
  try {
    const stored = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const isDark = stored ? stored === 'dark' : prefersDark
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light')
  } catch (e) {
    // localStorage unavailable (private browsing etc.) — fall back to system
  }
}
